import { IBaseCopyPaste } from '@src/slide/application/service/copy-paste/core/base/base-copy-paste.interface';
import { IBaseViewableServiceLayer } from '@src/slide/application/entry/toc/base/service-layer/base-viewable-service-layer.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { ICopyPasteInjectable } from '@src/slide/application/service/copy-paste/inject/copy-paste-injectable.interface';

export function initDynamicCopyPaste(
    copyPaste: IDynamicService<IBaseCopyPaste>,
    uiDataService: IUiDataService,
    menuManager: IMenuManager,
    viewableServices: IBaseViewableServiceLayer,
    inject: ICopyPasteInjectable,
): void {
    viewableServices.addonManager.setCopyPasteManager(copyPaste);
    copyPaste.onDidInit((copyPaste) => {
        copyPaste.setInject(inject);
        copyPaste.setServiceDelegates({
            uiDataService,
            selectionService: viewableServices.selectionService,
            menuManager,
            playManager: viewableServices.playManager,
            userPriviledgeService: viewableServices.userPriviledgeService,
            editingStateManager: viewableServices.editingStateManager,
            addonManager: viewableServices.addonManager,
            editorInstanceService: viewableServices.editorInstanceService,
            tipsManager: viewableServices.tipsManager,
            contentRendererService: viewableServices.contentRendererService,
        });
    });
}
